import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";

export function useOptInSend(id: string, onSuccess: () => void) {
    const [loading, setLoading] = useState(false);

    const send = useCallback(async () => {
        setLoading(true);
        try {
            await platformAPI.post(`api/contact-phone-opt-ins/${id}/send`);
            onSuccess();
        } finally {
            setLoading(false);
        }
    }, [id, onSuccess]);

    return {send, loading};
}

export function useOptInReset(id: string, onSuccess: () => void) {
    const [loading, setLoading] = useState(false);

    const reset = useCallback(async () => {
        setLoading(true);
        try {
            await platformAPI.post(`api/contact-phone-opt-ins/${id}/reset`);
            onSuccess();
        } finally {
            setLoading(false);
        }
    }, [id, onSuccess]);

    return {reset, loading};
}

export function useOptInMarkExempt(id: string, onSuccess: () => void) {
    const [loading, setLoading] = useState(false);

    const markExempt = useCallback(async () => {
        setLoading(true);
        try {
            await platformAPI.post(`api/contact-phone-opt-ins/${id}/mark-exempt`);
            onSuccess();
        } finally {
            setLoading(false);
        }
    }, [id, onSuccess]);

    return {markExempt, loading};
}

export function useOptInSendBulk(clientID: string | null, onSuccess: () => void) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const sendBulk = useCallback(async (includeFailed: boolean) => {
        setLoading(true);
        setError(null);
        try {
            await platformAPI.post("api/contact-phone-opt-ins/send-bulk", {
                clientID,
                includeFailed,
            });
            onSuccess();
        } catch (e) {
            if (isAxiosError(e) && e.response?.data?.error) {
                setError(e.response.data.error);
            } else {
                setError("An error has occurred");
            }
        } finally {
            setLoading(false);
        }
    }, [clientID, onSuccess]);

    return {sendBulk, loading, error};
}
